// extracted by mini-css-extract-plugin
module.exports = {"role_permissions":"role-permissions_role_permissions__3sKiK","group":"role-permissions_group__pqkZF","label":"role-permissions_label__uYX3x"};